
















































import Component, { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import ShowContainer from '@/common/mixin/ShowContainer';
import DetailRow from '@/common/component/DetailRow.vue';
import { dataLoggerApi } from '@/context/data_logger/api/DataLoggerApi';
import { DataLoggerShowModel } from '@/context/data_logger/model/DataLoggerShowModel';
import { notNullOrUndefined } from '@/utility/functions';
import { facilityRouter } from '@/context/facility/router/FacilityRouter';
// import FacilityShowContainer from "@/context/facility/containers/FacilityShowContainer.vue";
import ConfigurationShowContainer
  from '@/context/configuration/container/ConfigurationShowContainer.vue';
import ProgressSpinnerWrapper from '@/common/component/ProgressSpinnerWrapper.vue';

@Component({
  components: {
    ProgressSpinnerWrapper,
    ConfigurationShowContainer,
    // FacilityShowContainer,
    DetailRow
  }
})
export default class DataLoggerShowContainer extends mixins(ShowContainer) {
  model!: DataLoggerShowModel;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await dataLoggerApi.show(id);
    this.model = response?.data?.view;
  }

  // get facilityFetchable(): boolean {
  //   const result: boolean = notNullOrUndefined(this.model.facility);
  //   return result;
  // }

  get facilityRoute(): Record<string, unknown> | null {
    return this?.model?.facility ? facilityRouter.show(this.model.facility) : null;
  }

  get facilityLabel(): string {
    return this.model.facility ? "Przejdź do detali" : "";
  }

  get configurationFetchable(): boolean {
    const result: boolean = notNullOrUndefined(this.model.configuration);
    return result;
  }
}
